import { useEffect, useState } from "react";

const Datepicker = ({
  showDatepicker,
  setShowDatepicker,
  date,
  setDate,
  setFormData,
  name,
}) => {
  const getYears = () => {
    const startYear = new Date().getFullYear();
    const years = Array.from({ length: 10 }, (_, index) => startYear + index);
    return years;
  };

  const [selectedDate, setSelectedDate] = useState(date);

  useEffect(() => {
    if (
      selectedDate.getMonth() !== date.getMonth() ||
      selectedDate.getFullYear() !== date.getFullYear()
    ) {
      setSelectedDate(
        new Date(date.getFullYear(), date.getMonth(), selectedDate.getDate()),
      );
    }
  }, [date]);
  const daysInMonth = (year, month) => new Date(year, month + 1, 0).getDate();
  const firstDayOfMonth = (year, month) => new Date(year, month).getDay();
  const handlePrevMonth = () => {
    setDate(new Date(date.getFullYear(), date.getMonth() - 1, 1));
  };

  const handleNextMonth = () => {
    setDate(new Date(date.getFullYear(), date.getMonth() + 1, 1));
  };

  const handleMonthChange = (e) => {
    setDate(new Date(date.getFullYear(), parseInt(e.target.value), 1));
  };

  const handleYearChange = (e) => {
    setDate(new Date(parseInt(e.target.value), date.getMonth(), 1));
  };
  const handleDayClick = (day) =>
    setSelectedDate(new Date(date.getFullYear(), date.getMonth(), day));

  const handleApply = (e) => {
    e.preventDefault();
    setDate(selectedDate);
    setFormData((currentFormData) => ({
      ...currentFormData,
      [name]: selectedDate,
    }));
    setShowDatepicker(false);
  };

  const handleCancel = (e) => {
    e.preventDefault();
    setSelectedDate(date);
    setShowDatepicker(false);
  };

  const generateCalendarDays = () => {
    const totalDays = daysInMonth(date.getFullYear(), date.getMonth());
    const firstDay = firstDayOfMonth(date.getFullYear(), date.getMonth());

    const adjustedFirstDay = firstDay === 0 ? 6 : firstDay - 1;

    const days = [];
    for (let i = 0; i < adjustedFirstDay; i++) {
      days.push(
        <div
          key={`empty-${i}`}
          className="m-px size-10 flex justify-center items-center text-sm"
        >
          &nbsp;
        </div>,
      );
    }

    for (let day = 1; day <= totalDays; day++) {
      days.push(
        <button
          key={day}
          type="button"
          className={`m-px size-10 flex justify-center items-center border border-transparent text-sm ${
            selectedDate.getDate() === day &&
            selectedDate.getMonth() === date.getMonth() &&
            selectedDate.getFullYear() === date.getFullYear()
              ? "bg-teal-600 text-white"
              : "text-gray-800 hover:border-teal-600 hover:text-teal-600"
          } rounded-full disabled:text-gray-300    :border-gray-500`}
          onClick={() => handleDayClick(day)}
        >
          {day}
        </button>,
      );
    }

    return days;
  };
  return (
    <div
      className={`w-[16rem] flex flex-col overflow-hidden bg-white border shadow-lg rounded-xl      ${
        !showDatepicker && "hidden"
      }`}
    >
      <div className="p-3">
        <div className="space-y-0.5">
          <div className="grid grid-cols-10 items-center gap-x-3 mx-1.5 pb-3">
            <div className="col-span-1">
              <button
                onClick={handlePrevMonth}
                type="button"
                className="size-8 flex justify-center items-center text-gray-800 hover:bg-gray-100 rounded-full    :bg-gray-800"
              >
                <svg
                  className="flex-shrink-0 size-4"
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="m15 18-6-6 6-6" />
                </svg>
              </button>
            </div>
            <div className="col-span-8 flex justify-center items-center gap-x-1">
              <select
                value={date.getMonth()}
                onChange={handleMonthChange}
                className="py-2 px-3 pe-6 block w-full border-gray-200 shadow-sm rounded-lg text-sm focus:border-teal-500 focus:ring-teal-500 disabled:opacity-50 disabled:pointer-events-none        :ring-gray-600"
                //   data-hs-select='{
                //   "placeholder": "Select month",
                //   "toggleTag": "<button type=\"button\"></button>",
                //   "toggleClasses": "hs-select-disabled:pointer-events-none hs-select-disabled:opacity-50 relative flex text-nowrap w-full cursor-pointer text-start font-medium text-gray-800 hover:text-gray-600 focus:outline-none focus:text-gray-600 before:absolute before:inset-0 before:z-[1]    :text-gray-300  :text-gray-300",
                //   "dropdownClasses": "mt-2 z-50 w-32 max-h-72 p-1 space-y-0.5 bg-white border border-gray-200 rounded-lg shadow-lg overflow-hidden overflow-y-auto [&::-webkit-scrollbar]:w-2 [&::-webkit-scrollbar-thumb]:rounded-full [&::-webkit-scrollbar-track]:bg-gray-100 [&::-webkit-scrollbar-thumb]:bg-gray-300 dark:[&::-webkit-scrollbar-track]:bg-slate-700 dark:[&::-webkit-scrollbar-thumb]:bg-slate-500    ",
                //   "optionClasses": "p-2 w-full text-sm text-gray-800 cursor-pointer hover:bg-gray-100 rounded-lg focus:outline-none focus:bg-gray-100    :bg-slate-800    :bg-slate-800",
                //   "optionTemplate": "<div className=\"flex justify-between items-center w-full\"><span data-title></span><span className=\"hidden hs-selected:block\"><svg className=\"flex-shrink-0 size-3.5 text-gray-800  \" xmlns=\"http:.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><polyline points=\"20 6 9 17 4 12\"/></svg></span></div>"
                // }'
              >
                {Array.from({ length: 12 }, (_, i) => (
                  <option key={i} value={i}>
                    {new Date(0, i).toLocaleString("hr-HR", {
                      month: "long",
                    })}
                  </option>
                ))}
              </select>
              <span className="text-gray-800  ">/</span>
              <select
                value={date.getFullYear()}
                onChange={handleYearChange}
                className="py-2 px-3 pe-6 block w-full border-gray-200 shadow-sm rounded-lg text-sm focus:border-teal-500 focus:ring-teal-500 disabled:opacity-50 disabled:pointer-events-none        :ring-gray-600"

                //   data-hs-select='{
                //   "placeholder": "Select month",
                //   "toggleTag": "<button type=\"button\"></button>",
                //   "toggleClasses": "hs-select-disabled:pointer-events-none hs-select-disabled:opacity-50 relative flex text-nowrap w-full cursor-pointer text-start font-medium text-gray-800 hover:text-gray-600 focus:outline-none focus:text-gray-600 before:absolute before:inset-0 before:z-[1]    :text-gray-300  :text-gray-300",
                //   "dropdownClasses": "mt-2 z-50 w-32 max-h-72 p-1 space-y-0.5 bg-white border border-gray-200 rounded-lg shadow-lg overflow-hidden overflow-y-auto [&::-webkit-scrollbar]:w-2 [&::-webkit-scrollbar-thumb]:rounded-full [&::-webkit-scrollbar-track]:bg-gray-100 [&::-webkit-scrollbar-thumb]:bg-gray-300 dark:[&::-webkit-scrollbar-track]:bg-slate-700 dark:[&::-webkit-scrollbar-thumb]:bg-slate-500    ",
                //   "optionClasses": "p-2 w-full text-sm text-gray-800 cursor-pointer hover:bg-gray-100 rounded-lg focus:outline-none focus:bg-gray-100    :bg-slate-800    :bg-slate-800",
                //   "optionTemplate": "<div className=\"flex justify-between items-center w-full\"><span data-title></span><span className=\"hidden hs-selected:block\"><svg className=\"flex-shrink-0 size-3.5 text-gray-800  \" xmlns=\"http:.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><polyline points=\"20 6 9 17 4 12\"/></svg></span></div>"
                // }'
              >
                {getYears().map((year) => (
                  <option key={year} value={year}>
                    {year}
                  </option>
                ))}
              </select>
            </div>
            <div className="col-span-1 flex justify-end">
              <button
                onClick={handleNextMonth}
                type="button"
                className="size-8 flex justify-center items-center text-gray-800 hover:bg-gray-100 rounded-full    :bg-gray-800"
              >
                <svg
                  className="flex-shrink-0 size-4"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="m9 18 6-6-6-6" />
                </svg>
              </button>
            </div>
          </div>
        </div>
        {/* Days of the Week */}
        <div className="grid grid-cols-7 gap-1">
          {["Pon", "Uto", "Sri", "Cet", "Pet", "Sub", "Ned"].map((day) => (
            <div key={day} className="text-center text-sm text-gray-500">
              {day}
            </div>
          ))}
        </div>
        {/* Calendar Days */}
        <div className="grid grid-cols-7 gap-1 mt-2">
          {generateCalendarDays()}
        </div>
      </div>
      {/* Footer */}
      <div className="flex justify-end items-center gap-x-2 p-3 border-t  ">
        <button
          onClick={handleCancel}
          className="py-2 px-3 text-sm font-medium rounded-lg border bg-white text-gray-800 hover:bg-gray-50      :bg-gray-800"
        >
          Odustani
        </button>
        <button
          onClick={handleApply}
          className="py-2 px-3 text-sm font-semibold rounded-lg bg-teal-600 text-white hover:bg-teal-700"
        >
          Primijeni
        </button>
      </div>
    </div>
  );
};

export default Datepicker;
